import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import w1 from '../../img/Home/why1.webp';
import w2 from '../../img/Home/why2.webp';
import wm from '../../img/Home/whymob.webp';

import { Link } from "react-router-dom"

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Fade from 'react-reveal/Fade';

function WhyWait() {
  const { t } = useTranslation();

  const controlsDesktop = useAnimation();
  const controlsMobile = useAnimation();
  const controlsW2 = useAnimation();

  const [refDesktop, inViewDesktop] = useInView({ triggerOnce: true });
  const [refMobile, inViewMobile] = useInView({ triggerOnce: true });
  const [refW2, inViewW2] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inViewDesktop) {
      controlsDesktop.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" }
      });
    }
  }, [inViewDesktop, controlsDesktop]);

  useEffect(() => {
    if (inViewMobile) {
      controlsMobile.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" }
      });
    }
  }, [inViewMobile, controlsMobile]);

  useEffect(() => {
    if (inViewW2) {
      controlsW2.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" }
      });
    }
  }, [inViewW2, controlsW2]);

  return (
    <div className="pt-[100px] xl:pt-[200px]">
      <div className="xl:w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
        <div className="flex relative">
          {/* Десктоп версия */}
          <motion.div
            ref={refDesktop}
            initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
            animate={controlsDesktop}
            className={`hidden md:block ${i18n.language === 'ar' ? 'mr-auto' : ''}`}
          >
            <img src={w1} alt="Why desktop" />
          </motion.div>

          {/* Мобильная версия */}
          <motion.div
            ref={refMobile}
            initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
            animate={controlsMobile}
            className={`block md:hidden`}
          >
            <img src={wm} alt="Why mobile" />
          </motion.div>

          {/* Текст поверх картинки */}
          <div className="absolute right-0 bottom-0 xl:top-0 flex flex-col items-end">
            <p className="open-sans text-[#F26522] text-[50px] xl:text-[100px]">
              {t('home.94')}
            </p>
            <p className="open-sans text-[#F26522] text-[28px] xl:text-[30px]">
              {t('home.95')}
            </p>
          </div>
        </div>

        <div className={`flex justify-between ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
          {/* Текст слева */}
          <div>
            <p className="xl:max-w-[450px] font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] open-sans mt-[35px] xl:mt-[90px]">
                {t('home.96')}
            </p>

            <Link to="/form">
              <div className="contactus mt-[30px] hover:scale-[1.1] transition-all">
                <p className="text-[#1D1D1D] montserrat font-[600] text-[14px] xl:text-[16px]">{t('home.97')}</p>
              </div>
            </Link>
          </div>
        
          {/* Оранжевая полоса */}
          <Fade delay={1000}>
            <div className="hidden xl:block absolute w-[73px] h-[231px] bg-[#F26522] right-[36.5%] mt-[35px] z-50"></div>
          </Fade>

          {/* Второе изображение (только десктоп) */}
          <motion.div
            ref={refW2}
            initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
            animate={controlsW2}
            className={`mt-[-40px] relative hidden xl:block`}
          >
            <img src={w2} alt="Why extra" />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default WhyWait;
